import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface OrderStatus {
    order_status: number;
    order_status_text: string;
    count: number;
}

interface BranchStatus {
    branch_type: number;
    branch_text: string;
    count: number;
}

interface UseGetOrderCountResponse {
    today_count: number;
    order: OrderStatus[];
    branch: BranchStatus[];
    /* 지점계정 요청에만 실린다. 발주 시각 기준 신규 발주 알림용 */
    branch_latest_date?: string | null;
    branch_new_count?: number;
    /* 준비완료 사진이 올라왔는데 본점이 아직 확인하지 않은 건수 */
    photo_unchecked_count?: number;
}

export const useGetOrderCount = ({
    start_date,
    end_date,
    start_order_date,
    end_order_date,
    userOrder,
    branch_since,
}: {
    start_date: string;
    end_date: string;
    start_order_date?: string;
    end_order_date?: string;
    userOrder?: string;
    branch_since?: string;
}): UseQueryResult<UseGetOrderCountResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<UseGetOrderCountResponse, Error>({
        queryKey: ["getOrderCount", start_date, end_date, start_order_date, end_order_date, userOrder, branch_since],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_order_count}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    start_date,
                    end_date,
                    start_order_date,
                    end_order_date,
                    userOrder: userOrder || undefined,
                    branch_since: branch_since || undefined,
                },
            });
            return response.data.data;
        },
        placeholderData: prevData => {
            if (prevData) {
                return prevData;
            }
            return undefined;
        },
    });
};
